import { useEffect, useState } from "react";
import api from "../../../services/api";

export const useGetTableaurecordsByTableauId = (tableauId) => {

    const [tableauData, setTableauData] = useState({
        metadata: null,
        records: []
    });
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const getTableaurecords = async () => {
            setIsLoading(true);
            setError(null);

            try {
                const response = await api.get(`get_tableau_with_records_by_tableau_id/${tableauId}`);

                if (response.data.result) {
                    const { data } = response.data;

                    setTableauData({
                        metadata: {
                            id: data.id,
                            tableau_title: data.tableau_title,
                            tableau_title_ko: data.tableau_title_ko,
                            toc_id: data.toc_id,
                            toc_title: data.toc_title,
                            toc_title_ko: data.toc_title_ko,
                            book_title: data.book_title,
                            book_title_ko: data.book_title_ko,
                            book_number: data.book_number,
                            book_year: data.book_year,
                            page_start: data.page_start,
                            columns: JSON.parse(data.columns.replace(/'/g, '"')),
                            columns_ko: JSON.parse(data.columns_ko.replace(/'/g, '"'))
                        },
                        records: data.table_records.map(record => ({
                            id: record.tableaurecord_id,
                            order: record.record_order,
                            data_ko: JSON.parse(record.record_text_ko),
                            data_zh: JSON.parse(record.record_text_zh),
                            note: record.usernote
                        }))
                    });
                }
            } catch (error) {
                setError('Failed to fetch Tableaurecords data');
                console.error('Error fetching tableau records:', error);
            } finally {
                setIsLoading(false);
            }
        };

        if (tableauId) {
            getTableaurecords();
        }

    }, [tableauId]);

    return {
        data: tableauData,
        isLoading,
        error
    };
};